import React from "react"
import { Text } from "../Text"
import clsx from "clsx"

interface RadioButtonProps {
  name?: string
  value: string | undefined
  checked: boolean
  onChange?: (value: string) => void
  label?: string
  size?: "default" | "large"
}

export function RadioButton({ name, value, checked, onChange, label, size = "default" }: RadioButtonProps) {
  const input = (
    <input
      type="radio"
      name={name || value}
      value={value}
      checked={checked}
      onChange={() => value && onChange?.(value)}
      className={clsx(
        "form-radio cursor-pointer text-fg-1 checked:bg-fg-1 focus:ring-transparent",
        size === "large" && "size-7"
      )}
    />
  )
  if (label) {
    return (
      <label className="flex cursor-pointer items-center gap-x-2">
        {input}
        <Text>{label}</Text>
      </label>
    )
  } else {
    return input
  }
}
